var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "700" },
      model: {
        value: _vm.filterDialogVisible,
        callback: function ($$v) {
          _vm.filterDialogVisible = $$v
        },
        expression: "filterDialogVisible",
      },
    },
    [
      _c("customDialog", {
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.storeListVisible
                        ? _vm.t("storeSearch")
                        : _vm.t("filtering")
                    ) +
                    " "
                ),
                _c("button", { attrs: { id: "dialog_exit" } }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/popup_close.png"),
                      id: "btn_img",
                    },
                    on: {
                      click: function ($event) {
                        _vm.filterDialogVisible = false
                      },
                    },
                  }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "v-col",
                  { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                  [
                    _vm.brandBoxVisible == true
                      ? _c(
                          "v-col",
                          {
                            staticClass: "ma-0 pa-0",
                            attrs: { id: "brand_box", cols: "12" },
                          },
                          [
                            _c(
                              "v-row",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { align: "center", justify: "start" },
                              },
                              [
                                _vm.brandLoading == false
                                  ? [
                                      _c(
                                        "v-item-group",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: {
                                            dense: "",
                                            dark: "",
                                            "hide-details": "",
                                            column: false,
                                            multiple: "",
                                          },
                                          model: {
                                            value: _vm.selectedBrands,
                                            callback: function ($$v) {
                                              _vm.selectedBrands = $$v
                                            },
                                            expression: "selectedBrands",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: { align: "center" },
                                            },
                                            _vm._l(
                                              _vm.brandList,
                                              function (item, index) {
                                                return _c(
                                                  "v-col",
                                                  {
                                                    key: index,
                                                    staticClass:
                                                      "ma-0 pa-0 ml-1 mr-1 mb-1",
                                                    attrs: { cols: "auto" },
                                                  },
                                                  [
                                                    _c("v-item", {
                                                      attrs: { value: item },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var active =
                                                                ref.active
                                                              var toggle =
                                                                ref.toggle
                                                              return [
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    staticClass:
                                                                      "ma-0 pa-2 grey_item",
                                                                    class: {
                                                                      selected_item:
                                                                        active,
                                                                    },
                                                                    attrs: {
                                                                      cols: "auto",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        toggle,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-row",
                                                                      {
                                                                        staticClass:
                                                                          "ma-0 pa-0",
                                                                        attrs: {
                                                                          align:
                                                                            "center",
                                                                        },
                                                                      },
                                                                      [
                                                                        active
                                                                          ? [
                                                                              _c(
                                                                                "input",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      id: "check_box",
                                                                                      type: "checkbox",
                                                                                    },
                                                                                  domProps:
                                                                                    {
                                                                                      checked:
                                                                                        active,
                                                                                    },
                                                                                }
                                                                              ),
                                                                            ]
                                                                          : [
                                                                              _c(
                                                                                "input",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      id: "check_box",
                                                                                      type: "checkbox",
                                                                                    },
                                                                                  domProps:
                                                                                    {
                                                                                      checked:
                                                                                        active,
                                                                                    },
                                                                                }
                                                                              ),
                                                                            ],
                                                                        _c(
                                                                          "v-col",
                                                                          {
                                                                            staticClass:
                                                                              "ma-0 pa-0 ml-2",
                                                                            attrs:
                                                                              {
                                                                                cols: "auto",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " " +
                                                                                _vm._s(
                                                                                  item.brandName +
                                                                                    " (" +
                                                                                    item.count +
                                                                                    ")"
                                                                                ) +
                                                                                " "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      2
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  : [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-0 ml-5",
                                          attrs: { cols: "auto" },
                                        },
                                        [
                                          _c("v-progress-circular", {
                                            attrs: {
                                              indeterminate: "",
                                              color: "white",
                                              width: 4,
                                              size: 30,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                              ],
                              2
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.storeDataVisible && _vm.uacSupport
                      ? _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0 dialog_text",
                            attrs: { align: "center" },
                          },
                          [
                            _vm._v(" " + _vm._s(_vm.t("theConditions")) + ": "),
                            _vm.selectedBrands.length != 0 ||
                            !_vm.brandBoxVisible
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "ma-0 pa-2 ml-3",
                                    attrs: {
                                      width: "auto",
                                      height: "auto",
                                      id: "back_clean_btn",
                                      elevation: "0",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.filterOpen = !_vm.filterOpen
                                      },
                                    },
                                  },
                                  [
                                    _vm.filterOpen == false
                                      ? _c(
                                          "v-row",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            staticStyle: { color: "white" },
                                            attrs: { align: "center" },
                                          },
                                          [
                                            _c("v-img", {
                                              staticClass: "ma-0 pa-0 mr-2",
                                              attrs: {
                                                "max-height": "1rem",
                                                "max-width": "1rem",
                                                src: require("@/assets/images/plus_white.png"),
                                              },
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.t("filtering")) +
                                                " "
                                            ),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "v-row",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            staticStyle: { color: "white" },
                                            attrs: { align: "center" },
                                          },
                                          [
                                            _c("v-img", {
                                              staticClass: "ma-0 pa-0 mr-2",
                                              attrs: {
                                                "max-height": "1rem",
                                                "max-width": "1rem",
                                                id: "rotate_icon",
                                                src: require("@/assets/images/plus_white.png"),
                                              },
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.t("filtering")) +
                                                " "
                                            ),
                                          ],
                                          1
                                        ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "v-row",
                      {
                        staticClass: "ma-0 pa-0 pt-4 pb-7",
                        attrs: { justify: "center" },
                      },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "ma-0 pa-0",
                            attrs: {
                              cols: "12",
                              align: "left",
                              id: "store_list",
                            },
                          },
                          [
                            _vm.filterOpen == false
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0 pl-1 pr-1",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _vm.areaLoading == false
                                      ? [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: {
                                                cols: "12",
                                                id: "noneBorderBox",
                                              },
                                            },
                                            [
                                              _c("v-treeview", {
                                                attrs: {
                                                  "selected-color": "blue",
                                                  selectable: "",
                                                  dark: "",
                                                  dense: "",
                                                  "return-object": "",
                                                  items: _vm.storeList,
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "label",
                                                      fn: function (ref) {
                                                        var item = ref.item
                                                        return [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "ma-0 pa-0",
                                                              attrs: {
                                                                cols: "auto",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    item.id
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  4157034718
                                                ),
                                                model: {
                                                  value: _vm.selectedStores,
                                                  callback: function ($$v) {
                                                    _vm.selectedStores = $$v
                                                  },
                                                  expression: "selectedStores",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      : [
                                          _c(
                                            "v-row",
                                            {
                                              staticClass: "ma-0 pa-0 pb-2",
                                              attrs: { justify: "start" },
                                            },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "ma-0 pa-0",
                                                  attrs: { cols: "12" },
                                                },
                                                [
                                                  _c("v-skeleton-loader", {
                                                    attrs: {
                                                      boilerplate: false,
                                                      elevation: "0",
                                                      dark: "",
                                                      type: "list-item-three-line, list-item-two-line, list-item-three-line",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                  ],
                                  2
                                )
                              : _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      { staticClass: "ma-0 pa-0" },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-2 pr-4",
                                            staticStyle: {
                                              "border-right":
                                                "3px solid #4A4A4A",
                                            },
                                            attrs: {
                                              cols: "2",
                                              align: "right",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.t("cctvCamera")) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: { cols: "10" },
                                          },
                                          [
                                            _c(
                                              "v-row",
                                              {
                                                staticClass:
                                                  "ma-0 pa-2 pt-0 pl-4",
                                                attrs: { align: "center" },
                                              },
                                              [
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "ma-0 pa-0",
                                                    attrs: { cols: "4" },
                                                  },
                                                  [
                                                    _c(
                                                      "v-row",
                                                      {
                                                        staticClass:
                                                          "ma-0 pa-0",
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm
                                                                  .filterOptions
                                                                  .motion,
                                                              expression:
                                                                "filterOptions.motion",
                                                            },
                                                          ],
                                                          attrs: {
                                                            id: "check_box",
                                                            type: "checkbox",
                                                          },
                                                          domProps: {
                                                            checked:
                                                              Array.isArray(
                                                                _vm
                                                                  .filterOptions
                                                                  .motion
                                                              )
                                                                ? _vm._i(
                                                                    _vm
                                                                      .filterOptions
                                                                      .motion,
                                                                    null
                                                                  ) > -1
                                                                : _vm
                                                                    .filterOptions
                                                                    .motion,
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              var $$a =
                                                                  _vm
                                                                    .filterOptions
                                                                    .motion,
                                                                $$el =
                                                                  $event.target,
                                                                $$c =
                                                                  $$el.checked
                                                                    ? true
                                                                    : false
                                                              if (
                                                                Array.isArray(
                                                                  $$a
                                                                )
                                                              ) {
                                                                var $$v = null,
                                                                  $$i = _vm._i(
                                                                    $$a,
                                                                    $$v
                                                                  )
                                                                if (
                                                                  $$el.checked
                                                                ) {
                                                                  $$i < 0 &&
                                                                    _vm.$set(
                                                                      _vm.filterOptions,
                                                                      "motion",
                                                                      $$a.concat(
                                                                        [$$v]
                                                                      )
                                                                    )
                                                                } else {
                                                                  $$i > -1 &&
                                                                    _vm.$set(
                                                                      _vm.filterOptions,
                                                                      "motion",
                                                                      $$a
                                                                        .slice(
                                                                          0,
                                                                          $$i
                                                                        )
                                                                        .concat(
                                                                          $$a.slice(
                                                                            $$i +
                                                                              1
                                                                          )
                                                                        )
                                                                    )
                                                                }
                                                              } else {
                                                                _vm.$set(
                                                                  _vm.filterOptions,
                                                                  "motion",
                                                                  $$c
                                                                )
                                                              }
                                                            },
                                                          },
                                                        }),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "ma-0 pa-0 ml-3",
                                                            attrs: {
                                                              cols: "auto",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.t(
                                                                  "motionDetect"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "ma-0 pa-0",
                                                    attrs: { cols: "8" },
                                                  },
                                                  [
                                                    _c(
                                                      "v-row",
                                                      {
                                                        staticClass:
                                                          "ma-0 pa-0",
                                                        attrs: {
                                                          align: "center",
                                                          justify:
                                                            "space-between",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "ma-0 pa-0",
                                                            attrs: {
                                                              cols: "5.5",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "CustomDatePicker",
                                                              {
                                                                attrs: {
                                                                  viewTextField: true,
                                                                  reset:
                                                                    _vm.resetValue,
                                                                  initDate: true,
                                                                  filteredData:
                                                                    _vm.motionDetectBeginDate,
                                                                  disableFuture: true,
                                                                },
                                                                on: {
                                                                  resultDate:
                                                                    _vm.motionDetectBeginDateFunc,
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "ma-0 pa-0 pl-1 pr-1",
                                                            attrs: {
                                                              cols: "auto",
                                                              align: "center",
                                                            },
                                                          },
                                                          [_vm._v("~")]
                                                        ),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "ma-0 pa-0",
                                                            attrs: {
                                                              cols: "5.5",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "CustomDatePicker",
                                                              {
                                                                attrs: {
                                                                  viewTextField: true,
                                                                  reset:
                                                                    _vm.resetValue,
                                                                  filteredData:
                                                                    _vm.motionDetectEndingDate,
                                                                  disableFuture: true,
                                                                },
                                                                on: {
                                                                  resultDate:
                                                                    _vm.motionDetectEndingDateFunc,
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-row",
                                              {
                                                staticClass:
                                                  "ma-0 pa-2 pt-0 pl-4",
                                                attrs: { align: "center" },
                                              },
                                              [
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "ma-0 pa-0",
                                                    attrs: { cols: "4" },
                                                  },
                                                  [
                                                    _c(
                                                      "v-row",
                                                      {
                                                        staticClass:
                                                          "ma-0 pa-0",
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm
                                                                  .filterOptions
                                                                  .sound,
                                                              expression:
                                                                "filterOptions.sound",
                                                            },
                                                          ],
                                                          attrs: {
                                                            id: "check_box",
                                                            type: "checkbox",
                                                          },
                                                          domProps: {
                                                            checked:
                                                              Array.isArray(
                                                                _vm
                                                                  .filterOptions
                                                                  .sound
                                                              )
                                                                ? _vm._i(
                                                                    _vm
                                                                      .filterOptions
                                                                      .sound,
                                                                    null
                                                                  ) > -1
                                                                : _vm
                                                                    .filterOptions
                                                                    .sound,
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              var $$a =
                                                                  _vm
                                                                    .filterOptions
                                                                    .sound,
                                                                $$el =
                                                                  $event.target,
                                                                $$c =
                                                                  $$el.checked
                                                                    ? true
                                                                    : false
                                                              if (
                                                                Array.isArray(
                                                                  $$a
                                                                )
                                                              ) {
                                                                var $$v = null,
                                                                  $$i = _vm._i(
                                                                    $$a,
                                                                    $$v
                                                                  )
                                                                if (
                                                                  $$el.checked
                                                                ) {
                                                                  $$i < 0 &&
                                                                    _vm.$set(
                                                                      _vm.filterOptions,
                                                                      "sound",
                                                                      $$a.concat(
                                                                        [$$v]
                                                                      )
                                                                    )
                                                                } else {
                                                                  $$i > -1 &&
                                                                    _vm.$set(
                                                                      _vm.filterOptions,
                                                                      "sound",
                                                                      $$a
                                                                        .slice(
                                                                          0,
                                                                          $$i
                                                                        )
                                                                        .concat(
                                                                          $$a.slice(
                                                                            $$i +
                                                                              1
                                                                          )
                                                                        )
                                                                    )
                                                                }
                                                              } else {
                                                                _vm.$set(
                                                                  _vm.filterOptions,
                                                                  "sound",
                                                                  $$c
                                                                )
                                                              }
                                                            },
                                                          },
                                                        }),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "ma-0 pa-0 ml-3",
                                                            attrs: {
                                                              cols: "auto",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.t(
                                                                  "soundDetect"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "ma-0 pa-0",
                                                    attrs: { cols: "8" },
                                                  },
                                                  [
                                                    _c(
                                                      "v-row",
                                                      {
                                                        staticClass:
                                                          "ma-0 pa-0",
                                                        attrs: {
                                                          align: "center",
                                                          justify:
                                                            "space-between",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "ma-0 pa-0",
                                                            attrs: {
                                                              cols: "5.5",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "CustomDatePicker",
                                                              {
                                                                attrs: {
                                                                  viewTextField: true,
                                                                  reset:
                                                                    _vm.resetValue,
                                                                  initDate: true,
                                                                  filteredData:
                                                                    _vm.soundDetectBeginDate,
                                                                  disableFuture: true,
                                                                },
                                                                on: {
                                                                  resultDate:
                                                                    _vm.soundDetectBeginDateFunc,
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "ma-0 pa-0 pl-1 pr-1",
                                                            attrs: {
                                                              cols: "auto",
                                                              align: "center",
                                                            },
                                                          },
                                                          [_vm._v("~")]
                                                        ),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "ma-0 pa-0",
                                                            attrs: {
                                                              cols: "5.5",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "CustomDatePicker",
                                                              {
                                                                attrs: {
                                                                  viewTextField: true,
                                                                  reset:
                                                                    _vm.resetValue,
                                                                  filteredData:
                                                                    _vm.soundDetectEndingDate,
                                                                  disableFuture: true,
                                                                },
                                                                on: {
                                                                  resultDate:
                                                                    _vm.soundDetectEndingDateFunc,
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      {
                        staticClass: "ma-0 pa-0 pb-2",
                        attrs: { align: "center", justify: "center" },
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "ma-0 pa-0",
                            attrs: {
                              id: "grey_btn",
                              width: "8rem",
                              height: "2rem",
                            },
                            on: { click: _vm.resetData },
                          },
                          [_vm._v(_vm._s(_vm.t("reset")))]
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "ma-0 pa-0 ml-2",
                            attrs: {
                              id: "grey_btn",
                              width: "8rem",
                              height: "2rem",
                            },
                            on: {
                              click: function ($event) {
                                _vm.filterDialogVisible = false
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.t("cancel")))]
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "ma-0 pa-0 ml-2",
                            attrs: {
                              id: "blue_btn",
                              width: "8rem",
                              height: "2rem",
                            },
                            on: { click: _vm.editStores },
                          },
                          [_vm._v(_vm._s(_vm.t("confirm")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }